import Product from "./Product";
import ProductsFilter from "../utilities/OrganizationProductFilter";
import * as Constants from "../utilities/Constants";
import ValidationHelper from "../utilities/ValidationHelper";

export default class User {
    constructor (json) {
        this.site="";
        this.login="";
        this.userName = "";
        this.firstName = "";
        this.lastName = "";
        this.siteName = "";
        this.id = 0;
        this.isActive = true;

        this.email = "";
        this.phone = "";

        this.userProducts = [];
        this.lastLogin = "";

        this.isPasswordExpired = false;
        this.isLocked = false;

        this.userProductsString = "";
        this.userRolesString = "";
        this.orgId = 0;
        this.isValid = true;

        this.team = "";
        this.isLinkedToVirtualUser = false;

        if (json)
            mapJsonToUser(json, this);
    }


    createCopy () {
        const user = new User();
        user.id = this.id;
        user.firstName = this.firstName;
        user.lastName = this.lastName;
        user.site = this.site;
        user.siteName = this.siteName;
        user.login = this.login;
        user.phone = this.phone;
        user.email = this.email;
        user.userProducts = [];
        user.userName = this.userName;

        if (this.userProducts && this.userProducts.length > 0) {
            this.userProducts.forEach(p => user.userProducts.push(p.createCopy()));
        }

        user.isValid = this.isValid;
        user.orgId = this.orgId;
        user.userRolesString = this.userRolesString;
        user.userProductsString = this.userProductsString;
        user.isLocked = this.isLocked;
        user.isPasswordExpired = this.isPasswordExpired;
        user.isActive = this.isActive;
        user.role = this.role;

        user.team = this.team;
        user.isLinkedToVirtualUser = this.isLinkedToVirtualUser;
        return user;
    }

    toJson () {
        var json = {};
        mapUserToJson(this, json);
        return json;
    }

    isValidData () {
        if (ValidationHelper.isNullOrEmpty(this.firstName))
            return false;
        if (ValidationHelper.isNullOrEmpty(this.lastName))
            return false;

        if (!ValidationHelper.isNullOrEmpty(this.email) && !ValidationHelper.isValidEmailFormat(this.email)) {
            return false;
        }

        if (!ValidationHelper.isNullOrEmpty(this.phone) && !ValidationHelper.isValidPhoneNumber(this.phone)) {
            return false;
        }

        return true;
    }

    getUserName () {
        return formatUserName(this.firstName, this.lastName);
    }

    createDefault (organization, productRoles) {
        this.site = organization.site;
        this.orgId = organization.id;
        this.team = TeamName;
        var availableProducts = ProductsFilter.filterProductsJS(organization.products);
        availableProducts.forEach((orgProd) => {
            const defaultRole = this.getDefaultProductRole(productRoles, orgProd.productId);
            const userProduct = new Product();
            userProduct.productId = orgProd.productId;
            userProduct.productName = orgProd.productName;
            userProduct.assigned = true;

            if (defaultRole) {
                userProduct.roleId = defaultRole.id;
                userProduct.roleName = defaultRole.name;
            }
            this._assignUserProduct(userProduct, organization.products);
        });
    }

    getDefaultProductRole (productRoles, productId) {
        if (productRoles && productRoles.length > 0) {
            const product = productRoles.find(p => p.productId === productId);
            if (product && product.roles && product.roles.length > 0) {
                return product.roles.find(r => r.isDefault);
            }
        }
        return undefined;
    }

    _assignUserProduct(userProduct, organizationProducts) {
        var productIndex = this.userProducts.findIndex(p => p.productId === userProduct.productId);

        if (userProduct.assigned) {
            var product = new Product();
            product.roleId = userProduct.roleId;
            product.roleName = userProduct.roleName;
            product.productId = userProduct.productId;
            product.productName = userProduct.productName;

            (productIndex < 0) ? this.userProducts.push(product) : this.userProducts[productIndex] = product;
        }
        else {
            if (productIndex >= 0) {
                this.userProducts.splice(productIndex, 1);
            }
        }

        if (organizationProducts) {
            this._addS7DforS7(userProduct, organizationProducts);
        }
    }

    _addS7DforS7 (userProduct, organizationProducts) {
        if (userProduct.productName === Constants.ORGANIZATION_PRODUCT_SENTRI7) {
            var s7DProductIndex = organizationProducts.findIndex(p => p.productName === Constants.ORGANIZATION_PRODUCT_SENTRI7DOCUMENTATION);

            if (s7DProductIndex >= 0) {
                var s7dProduct = new Product();
                s7dProduct.roleId = Constants.SENTRI7DOCUMENTATION_ROLE_ID;
                s7dProduct.roleName = Constants.SENTRI7DOCUMENTATION_ROLE_NAME;
                s7dProduct.productId = organizationProducts[s7DProductIndex].productId;
                s7dProduct.productName = organizationProducts[s7DProductIndex].productName;
                s7dProduct.assigned = userProduct.assigned;

                // BUG-589 Add S7D with S7 for InfectionPrevention target users only. Always remove S7D with S7
                if (this.team === Constants.ORGANIZATION_TEAM_INFECTION_PREVENTION || !userProduct.assigned) {
                    this._assignUserProduct(s7dProduct);
                }
            }
        }
    }
}

const formatUserName = (firstName, lastName) => {
    var separator = ", ";
    if (lastName == null
        || firstName == null
        || lastName.trim() === ""
        || firstName.trim() === "") {
        separator = "";
    }
    return lastName + separator + firstName;
};

const mapJsonToUser = (json, user) => {
    user.site = json.Site;
    user.login = json.Login;

    user.siteName = json.OrganizationName;
    user.id = json.Id;
    user.isActive = json.IsActive;

    user.orgId = json.OrganizationId;

    if (json.Contact) {
        user.email = json.Contact.Email;
        user.firstName = json.Contact.FirstName;
        user.lastName = json.Contact.LastName;
        user.phone = json.Contact.Phone;

        user.userName = formatUserName(user.firstName, user.lastName);
    }

    if (json.LastLoginDateTime && json.LastLoginDateTime != null) {
        user.lastLogin = json.LastLoginDateTime;
    }

    if (json.UserProducts) {
        user.userProducts = json.UserProducts.map((product) => new Product(product));

        getProductAndRolesString(user);
    }

    user.role = json.Role;
    user.isPasswordExpired = json.IsPasswordExpired;
    user.isLocked = json.IsLocked;

    if (json.Team) {
        user.team = json.Team.Name;
    }

    user.isLinkedToVirtualUser = json.IsLinkedToVirtualUser;
};

const getProductAndRolesString = (user) => {
    var productsToShow = [];
    var rolesToShow = [];
    var products = ProductsFilter.filterProductsJS(user.userProducts);

    products.forEach(p => {
        productsToShow.push(p.productName);
        rolesToShow.push(p.roleName);
    });
    user.userProductsString = productsToShow.join(', ');
    user.userRolesString = rolesToShow.join(', ');
};

const mapUserToJson = (user, json) => {
    json.UserId = user.id;
    json.FirstName = user.firstName;
    json.LastName = user.lastName;
    json.OrgId = user.orgId;
    json.Password = user.password;
    json.Phone = user.phone;
    json.Email = user.email;
    json.IsLinkedToVirtualUser = user.isLinkedToVirtualUser;
};

